<template>
  <b-container>
    <b-breadcrumb>
      <b-breadcrumb-item to="/admin">Admin</b-breadcrumb-item>
      <b-breadcrumb-item active>Meetings</b-breadcrumb-item>
    </b-breadcrumb>
    <h1>All Meetings</h1>
    <meetings-table :count="25" pagination />
  </b-container>
</template>

<script>
import MeetingsTable from '@/components/admin/MeetingsTable'

export default {
  name: 'Meetings',
  components: {
    MeetingsTable
  }
}
</script>
